var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n   You can add values to the table with fields you defined.\n    "),_c('br'),_c('br'),_c('img',{attrs:{"src":"/img/tutorials/table_custom.gif","width":"100%"}})])
}]

export { render, staticRenderFns }